import React, { useEffect, useState } from "react";
import { formatUSD } from "../../Services/CommonServices/helper";
import { useSelector, useDispatch } from "react-redux";
import { isStreamingStarted, loader } from "../../Services/Redux/Reducers/commonSlice";
import { storeChat } from "../../Services/Redux/Reducers/chatSlice";
import SwiperCard from "../../CommonComponents/SwiperCard";
import { ProductDetailPageProps } from "../../Services/CommonServices/propTypes";

function ProductDetailPage(props) {
  const [sortedMedia, setSortedMedia] = useState([]);
  const dispatch = useDispatch();
  const conList = useSelector((state) => state.chat.conversationList);
  const loading = useSelector((state) => state.common.isLoader);
  useEffect(() => {
    if (((props.index === conList.length - 1 && loading) && (props.text || props.conclusion))) {
      dispatch(isStreamingStarted(false));
    }
    if (props.index === conList.length - 1 && props.isAnswerComplete) {
      dispatch(storeChat(true));
      dispatch(loader(false));
    }
  }, [props.text, props.conclusion, props.isAnswerComplete]);
  useEffect(() => {
    if (
      props.product &&
      props.product !== null &&
      props.product.length > 0 &&
      props.product[0].media &&
      props.product[0].media !== null
    ) {
      // Sort media to ensure offbody images appear last
      if (props.product[0].media && props.product[0].media.length > 0) {
        // Create a copy of the media array for sorting
        const mediaToSort = [...props.product[0].media];
        // Sort function: videos first, then onbody/other images, then offbody/lifestyle images last
        mediaToSort.sort((a, b) => {
          // Videos always come first
          if (a.type === "Video" && b.type !== "Video") return -1;
          if (a.type !== "Video" && b.type === "Video") return 1;

          // Images with "lifestyle" in URL are offbody images - they should go last
          const aIsOffbody = a.url && (a.url.includes('lifestyle') || a.url.includes('_main'));
          const bIsOffbody = b.url && (b.url.includes('lifestyle') || b.url.includes('_main'));

          // If one is offbody and other is not, the offbody goes last
          if (aIsOffbody && !bIsOffbody) return 1; // Offbody goes to end
          if (!aIsOffbody && bIsOffbody) return -1; // Non-offbody comes before
          // If both are offbody or both are not offbody, maintain original order
          return 0;
        });
        setSortedMedia(mediaToSort);
      }
    }
  }, [props.product]);

  const handleClick = (product, type) => {
    if (product && product.length > 0) {
      let data = {}
      if (type === "quickshop") {
        data = {
          text: "",
          query: "",
          type: type,
          convoId: props.convoId,
          id: product[0].id,
          shopClicked: props.product.shopClicked,
        };
        // // Enhanced programmatic link creation for iPhone app compatibility
        // const a = document.createElement("a");
        // a.href = product[0].url;
        // a.target = '_blank';
        // a.rel = 'noopener noreferrer';
        // a.style.display = 'none';

        // // Add to DOM, click, then remove
        // document.body.appendChild(a);
        // a.click();
        // setTimeout(() => {
        //   document.body.removeChild(a);
        // }, 100);
        window.open(product[0].url, "_blank", "noopener,noreferrer");
      } else if (type === "refresh") {
        data = {
          text: "Show me alternatives for the " + product[0].name + ".", //as per Peter's comment
          query: "Show me alternatives for the product with ID " + product[0].id + ".",
          type: type,
        };
      }
      props.onValueChange(data);
    }
  };

  const handlePDPNavigation = (product) => {
    // // Enhanced programmatic link creation for iPhone app compatibility
    // const a = document.createElement("a");
    // a.href = product.url;
    // a.target = '_blank';
    // a.rel = 'noopener noreferrer';
    // a.style.display = 'none';

    // // Add to DOM, click, then remove
    // document.body.appendChild(a);
    // a.click();
    // setTimeout(() => {
    //   document.body.removeChild(a);
    // }, 100);
    window.open(product.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      {
        (props.text || props.products || props.conclusion) && (
          <div
            className="single-look-template"
            style={{ zIndex: 1, position: "relative" }}
          >
            <div className="row">
              <div className=" col-12 look-description" style={{ marginBottom: "30px" }}>{props.text}</div>
            </div>
            <div className="row">
              {props.product && props.product?.length > 0 && (
                <>
                  <button type="button" name="pdpNavigation" className="border-0 bg-transparent text-start product-titles cursor-pointer" onClick={() => handlePDPNavigation(props.product[0])}>{props.product[0]?.name}</button>
                  {/* <a
                    href={props.product[0]?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border-0 bg-transparent text-start product-titles cursor-pointer"
                    style={{ textDecoration: "none" }}
                    onClick={() => {
                      localStorage.setItem('singleLookScrollIndex', 0);
                      handlePDPNavigation(props.product[0])}}
                  >
                    {props.product[0]?.name}
                  </a> */}
                  <div className="prices" style={{ marginBottom: "-9px" }}>{`${formatUSD(props.product[0]?.price)}`}</div>

                  <div className="">
                    <div className="">
                      <SwiperCard
                        product={props.product[0]}
                        sortedMedia={sortedMedia}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="look-description" style={{ marginBottom: "20px" }}>{props.conclusion}</div>
              {props.product && props.product?.length > 0 &&
                <div className="">
                  <button
                    // href={props.product[0]?.url}
                    // target="_blank"
                    // rel="noopener noreferrer"
                    type="button"
                    name="addToBagButton"
                    className="add_to_bag_btn d-flex align-items-center justify-content-center"
                    style={{ textDecoration: "none", pointerEvents: loading ? "none" : "auto" }}
                    onClick={() => {
                      localStorage.setItem('singleLookScrollIndex', 0);
                      handleClick(props.product, "quickshop");
                    }}
                    aria-disabled={loading}
                  >
                    <img
                      src="/static/assets/shop_icon_updated.svg"
                      alt="shop_icon"
                      width="13px"
                      height="14px"
                    />
                    <span className="add_bag_text">Add to Bag</span>
                  </button>
                  {!props.stopClick && (
                    <button
                      name="similarStylesButton"
                      className="similar_styles_btn d-flex align-items-center justify-content-center"
                      disabled={loading}
                      onClick={() => handleClick(props.product, "refresh")}
                    >
                      <img
                        src="/static/assets/similar_icon.svg"
                        alt="similarstyle_icon"
                        width="11.85px"
                        height="11.85px"
                      />
                      <span className="see-similar-text">See Similar</span>
                    </button>
                  )}
                </div>
              }
            </div>
          </div>
        )
      }
    </div>
  );
}

ProductDetailPage.propTypes = ProductDetailPageProps;

export default ProductDetailPage;
